import React from "react"
import Layout from "../components/layout"
import styles from "./../styles/modules/index.module.scss"
import { graphql } from "gatsby"
import SEO from "./../components/seo"
import BackgroundImage from "gatsby-background-image"
import Slider from "./../components/slider/slider.module"
import Produit from "./../components/produit/produit.module"
import Tryus from "../components/tryus/tryus.module"
import Why from "./../components/why/why.module"
import Contact from "./../components/contact/contact.module"

export default ({ data }) => {
  return (
    <Layout>
      <div className="row">
        <div className="col-lg-12 p-0">
          <BackgroundImage
            Tag="section"
            className={styles.slider}
            fluid={data.slide.childImageSharp.fluid}
          />
        </div>
      </div>
      <SEO
        title="Le titan media"
        description="Letitan Media, première plateforme de publicité mobileAlgérienne, est un média embarqué dédié à la diffusiond’annonces publicitaire s et au divertissement via un réseau de tablettes embarquées dans les taxis à Alger et dans d’autres grandes villes d’Algérie."
        lang="fr"
        keywords={[`letitanmedia`, `publicité`, `taxi`, `algérie`]}
      />
      <Slider />
      <Why />
      <Produit />
      <Tryus />
      <Contact />
    </Layout>
  )
}

export const query = graphql`
  query {
    slide: file(relativePath: { eq: "fhome.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
